/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandPlant = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 7c-2.568 0-4.2.678-5.212 1.473-1.021.802-1.474 1.772-1.61 2.458-.308 1.573-.186 2.705.129 3.517.04.103.083.203.13.298 2.49-3.298 5.479-5.087 7.238-5.692l.65 1.892c-1.455.5-4.222 2.141-6.499 5.287 1.331.8 3.133.882 4.263.662 3.642-.845 5.883-3.29 7.223-6.137.848-1.803 1.32-3.74 1.539-5.462-2.42 1.84-5.422 1.762-7.193 1.716C12.413 7.006 12.193 7 12 7zm-7.779 9.558a5.52 5.52 0 0 1-.78-1.388c-.483-1.248-.587-2.78-.225-4.624.223-1.134.921-2.534 2.337-3.646C6.978 5.78 9.068 5 12 5c.236 0 .483.004.738.008 2.404.038 5.56.089 7.402-3.018l1.86.482c.065 2.378-.364 5.919-1.879 9.138-1.526 3.242-4.193 6.222-8.598 7.238l-.015.003-.016.003c-1.469.291-3.854.224-5.746-.938a19.015 19.015 0 0 0-1.782 4.348l-1.928-.528a20.928 20.928 0 0 1 2.185-5.178z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHandPlant as HandPlant };
